import { baseApi } from "../baseApi";

const PREPAYMENT_BASE_URL = "prepayments";

export const prepaymentApi = baseApi.injectEndpoints({
  tagTypes: ["Prepayment"],

  endpoints: (build) => ({
    createPrepayment: build.mutation({
      query: (body) => ({
        url: PREPAYMENT_BASE_URL,
        method: "POST",
        body,
      }),
    }),

    listPrepayment: build.query({
      query: (params) => ({
        url: PREPAYMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Prepayment", _id })),
              { type: "Prepayment", id: "LIST" },
            ]
          : [{ type: "Prepayment", id: "LIST" }],
    }),

    getPrepaymentDetail: build.query({
      query: (id) => `${PREPAYMENT_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Prepayment", id },
        { type: "Prepayment", id: "LIST" },
      ],
    }),

    getPrepaymentDDL: build.query({
      query: (params) => {
        return { url: `${PREPAYMENT_BASE_URL}/ddl`, params };
      },
      providesTags: (result, error, id) => [
        { type: "Prepayment", id },
        { type: "Prepayment", id: "LIST" },
      ],
    }),

    updatePrepayment: build.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${PREPAYMENT_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Prepayment", _id },
        { type: "Prepayment", id: "LIST" },
      ],
    }),

    listShipmentsByPrepaymentId: build.query({
      query: ({ prepaymentId, page, limit }) => ({
        url: `${PREPAYMENT_BASE_URL}/${prepaymentId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Prepayment", id: _id },
        { type: "Prepayment", id: "LIST" },
      ],
    }),

    getPrepaymentTransactionHistory: build.query({
      query: ({ prepaymentId, page, limit }) => ({
        url: `${PREPAYMENT_BASE_URL}/${prepaymentId}/transactions`,
        params: { page, limit },
      }),
      providesTags: (result, error, { prepaymentId }) => [
        { type: "Prepayment", id: prepaymentId },
        { type: "Prepayment", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useCreatePrepaymentMutation,
  useLazyListPrepaymentQuery,
  usePrepaymentDetailQuery,
  useUpdatePrepaymentMutation,
  useGetPrepaymentDetailQuery,
  useLazyGetPrepaymentDDLQuery,
  useLazyListShipmentsByPrepaymentIdQuery,
  useLazyGetPrepaymentTransactionHistoryQuery,
} = prepaymentApi;